<ul class="tree">
  <li *ngFor="let node of nodes; let i = index; trackBy: trackByNode" [@fadeSlide]
    [ngClass]="{ 'iconOnly': !open, 'double-icon': node.action }">

    <div class="node" (click)="toggleNode(node)"
      [ngClass]="{ 'parent': node.parent , 'iconOnly': !open, 'active': isRouteActive(node.route)}"
      [matTooltip]="!open ? (node.name | translate) : null" matTooltipPosition="right" [matTooltipShowDelay]="200">

      <a *ngIf="node.route" (click)="navigateToRoute(node.route)" routerLinkActive="node-selected"
        #rla="routerLinkActive" [ngClass]="{'node-selected': true}">
        <mat-icon *ngIf="node.icon">{{ node.icon }}</mat-icon>

        <span *ngIf="open" class="title">
          {{ node.name | translate }}
        </span>
      </a>

      <span *ngIf="!node.route && open" class="parent-title">{{ node.name | translate | uppercase }}</span>

      <div *ngIf="!node.loading" class="icons-container">
        <mat-icon *ngIf="node.action" (click)="$event.stopPropagation(); node.action.click!()" class="action">
          {{ node.action.icon }}
        </mat-icon>

        <mat-icon *ngIf="node.parent">
          {{ node.expanded ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </div>

      <app-spinner *ngIf="node.loading" class="spinner" [diameter]="15" iconOnly></app-spinner>
    </div>

    <div [@expandCollapse]="node.expanded ? 'expanded' : 'collapsed'" style="overflow: hidden;">
      <ng-container *ngIf="node.expanded || node.children?.length">
        <app-nested-navigation
          [nodes]="(node.fullyExpanded || node.fullyExpanded == undefined) ? node.children : node.children.slice(0, 5)"
          [open]="open">
        </app-nested-navigation>
      </ng-container>
    </div>

    <!-- FULLY EXPAND BUTTON -->
    <div
      *ngIf="node.parent && node.expanded && !node.loading && node.children && node.children.length > 5 && node.fullyExpanded !== undefined"
      class="fully-expand" (click)="toggleFullNode(node)">

      <mat-icon [ngClass]="{ 'expanded': node.fullyExpanded }">
        {{ !node.fullyExpanded ? 'expand_more' : 'expand_less' }}
      </mat-icon>
    </div>

    <!-- DIVIDER -->
    <div class="divider"
      *ngIf="(node.children?.length && i < nodes.length - 1) || (node.parent && !node.children?.length)">
      <mat-divider></mat-divider>
    </div>
  </li>
</ul>